'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ramda = require('ramda');

var _sanitize_utility = require('../../../packages/common-utilities/src/sanitize_utility.js');

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KeyRisksCard = function (_React$PureComponent) {
  _inherits(KeyRisksCard, _React$PureComponent);

  function KeyRisksCard(props) {
    _classCallCheck(this, KeyRisksCard);

    return _possibleConstructorReturn(this, (KeyRisksCard.__proto__ || Object.getPrototypeOf(KeyRisksCard)).call(this, props));
  }

  _createClass(KeyRisksCard, [{
    key: 'renderDynamicText',
    value: function renderDynamicText(type) {
      var fundMarketingTranslationText = (0, _ramda.find)((0, _ramda.propEq)("typeName", type))(this.props.keyRisksText);
      if ((0, _ramda.isNil)(fundMarketingTranslationText)) {
        return null;
      }
      return _react2.default.createElement('div', { className: "category", 'data-testid': type, dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(fundMarketingTranslationText.fundMarketingTranslationText) } });
    }
  }, {
    key: 'render',
    value: function render() {
      var breakpoint = this.props.breakpoint;

      var keyRisksPart1 = "The Sub-Fund is subject to <span className='font-normal'>Investment risks</span> and <span className='font-normal'>Other associated risks</span> from the techniques and securities it uses to seek to achieve its objective. The table below explains how these risks relate to each other and the <span className='font-normal'>Outcomes to the Shareholder</span> that could affect an investment in the Sub-Fund.";
      var keyRisksPart2 = "Investors should also read <span className='font-normal'>Risk Descriptions</span> in the Prospectus for a full description of each risk.";

      return _react2.default.createElement(
        _card_component2.default,
        {
          headerTitle: _string_utility2.default.renderFormattedLabel("Key risks", "pdp-key-risks-label"),
          headerTitleId: "key-risks",
          headerTitleLabel: "key-risks",
          headerLabel: "",
          breakpoint: breakpoint,
          dataTest: "key-risks-card-component"
        },
        _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(
            'div',
            { 'data-testid': 'key-risks-intro' },
            _react2.default.createElement(
              'p',
              null,
              _string_utility2.default.renderFormattedHTMLLabel(keyRisksPart1, "pdp-key-risks-part-1", { fundType: this.props.fundType })
            ),
            _react2.default.createElement(
              'p',
              null,
              _string_utility2.default.renderFormattedHTMLLabel(keyRisksPart2, "pdp-key-risks-part-2")
            )
          ),
          _react2.default.createElement(
            'div',
            { className: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xlg-4 padding-left-0 margin-bottom-20 padding-right-25" },
            KeyRisksCard.renderCardSegment(_string_utility2.default.renderFormattedLabel("Investment risks", "pdp-key-risks-investment-risks-label"), _string_utility2.default.renderFormattedLabel("Risks from the Sub-Fund’s techniques and securities", "pdp-key-risks-investment-risks-text", { fundType: this.props.fundType }), "pdp-key-risks-investment-risks", this.props.breakpoint),
            _react2.default.createElement(
              'div',
              { className: "margin-bottom-10" },
              KeyRisksCard.renderSubHeaderAndList(_string_utility2.default.renderFormattedLabel("Techniques", "pdp-key-risks-techniques-label"), this.renderDynamicText("INVESTEMENT_RISK_TECHNIQUE"), "key-risks margin-bottom-18"),
              KeyRisksCard.renderSubHeaderAndList(_string_utility2.default.renderFormattedLabel("Securities", "pdp-key-risks-securities-label"), _react2.default.createElement('div', {
                className: 'category',
                'data-testid': 'key-risks-securities',
                dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(this.formattedRiskSecuritiesString) } }), "key-risks")
            )
          ),
          _react2.default.createElement(
            'div',
            { className: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xlg-4 padding-left-0 margin-bottom-20 padding-right-25" },
            KeyRisksCard.renderCardSegment(_string_utility2.default.renderFormattedLabel("Other associated risks", "pdp-key-risks-other-associated-risks-label"), _string_utility2.default.renderFormattedLabel("Further risks the Sub-Fund is exposed to from its use of the techniques and securities above", "pdp-key-risks-other-associated-risks-text", { fundType: this.props.fundType }), "pdp-key-risks-other-associated-risks", this.props.breakpoint),
            _react2.default.createElement('div', { className: 'tag key-risks',
              'data-testid': 'other-associated-risks',
              dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(this.formattedTranslationString) } })
          ),
          _react2.default.createElement(
            'div',
            { className: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xlg-4 padding-left-0 margin-bottom-20" },
            KeyRisksCard.renderCardSegment(_string_utility2.default.renderFormattedLabel("Outcomes to the Shareholder", "pdp-key-risks-outcomes-to-shareholder-label"), _string_utility2.default.renderFormattedLabel("Potential impact of the risks above", "pdp-key-risks-outcomes-to-shareholder-text"), "pdp-key-risks-outcomes-to-shareholder", this.props.breakpoint),
            _react2.default.createElement(
              'div',
              null,
              KeyRisksCard.renderSubHeaderAndList(_string_utility2.default.renderFormattedLabel("Loss", "pdp-key-risks-loss-label"), _string_utility2.default.renderFormattedLabel("Shareholders could lose some or all of their money.", "pdp-key-risks-loss-text"), "margin-bottom-18"),
              KeyRisksCard.renderSubHeaderAndList(_string_utility2.default.renderFormattedLabel("Volatility", "pdp-key-risks-volatility-label"), _string_utility2.default.renderFormattedLabel("Shares of the Sub-Fund will fluctuate in value.", "pdp-key-risks-volatility-text", { fundType: this.props.fundType }), "margin-bottom-18"),
              KeyRisksCard.renderSubHeaderAndList(_string_utility2.default.renderFormattedHTMLLabel("Failure to meet the Sub-Fund's objective", "pdp-key-risks-failure-to-meet-objective-label", { fundType: this.props.fundType }), null, "")
            )
          )
        )
      );
    }
  }, {
    key: 'formattedTranslationString',
    get: function get() {
      var _props = this.props,
          breakpoint = _props.breakpoint,
          keyRisksText = _props.keyRisksText;

      var fundMarketingTranslationText = (0, _ramda.find)((0, _ramda.propEq)("typeName", 'OTHER_ASSOCIATED_RISK'))(keyRisksText);

      if ((0, _ramda.isNil)(fundMarketingTranslationText)) {
        return '';
      }

      var numberOfTags = fundMarketingTranslationText.fundMarketingTranslationText.match(/<\//g).length;

      if (breakpoint < 3 || numberOfTags <= 3) {
        return '<div>' + fundMarketingTranslationText.fundMarketingTranslationText + '</div>';
      }

      var risksSplitByTags = fundMarketingTranslationText.fundMarketingTranslationText.split(/(<\/[a-z]+>)/gi);
      var processedRisks = [];

      for (var i = 0; i < risksSplitByTags.length; i++) {
        if (i % 2 !== 0) {
          processedRisks.push(risksSplitByTags[i - 1] + risksSplitByTags[i]);
        }
      }

      var columns = (0, _ramda.splitEvery)(2, processedRisks);

      var translationString = '';
      var joinFunction = function joinFunction(x) {
        translationString += '<div>' + x.join('') + '</div>';
      };
      (0, _ramda.forEach)(joinFunction, columns);

      return translationString;
    }
  }, {
    key: 'formattedRiskSecuritiesString',
    get: function get() {
      var _props2 = this.props,
          riskSecuritiesString = _props2.riskSecuritiesString,
          breakpoint = _props2.breakpoint;

      if ((0, _ramda.isNil)(riskSecuritiesString)) {
        return "";
      }

      if (breakpoint < 3) {
        return '<div>' + riskSecuritiesString + '</div>';
      }

      var numberOfTags = riskSecuritiesString.match(/<\//g).length;
      var indexOfMidPoint = Math.ceil(numberOfTags / 2);
      var riskSecuritiesSplitByTags = riskSecuritiesString.split(/(<\/[a-z]+>)/gi);
      var processedRiskSecurities = [];

      for (var i = 0; i < riskSecuritiesSplitByTags.length; i++) {
        if (i % 2 !== 0) {
          processedRiskSecurities.push(riskSecuritiesSplitByTags[i - 1] + riskSecuritiesSplitByTags[i]);
        }
      }
      var columns = (0, _ramda.splitAt)(indexOfMidPoint, processedRiskSecurities);
      return '<div>' + columns[0].join("") + '</div><div>' + columns[1].join("") + '</div>';
    }
  }], [{
    key: 'renderCardSegment',
    value: function renderCardSegment(textheader, textContent, testID, breakpoint) {
      return _react2.default.createElement(
        'div',
        { className: '' + (breakpoint > 3 ? "margin-bottom-14 min-height-105" : "margin-bottom-10"), 'data-testid': testID },
        _react2.default.createElement(
          'p',
          { className: "body2 margin-all-0" },
          _react2.default.createElement(
            'div',
            { className: 'sub-header-3' },
            textheader,
            ' '
          ),
          _react2.default.createElement(
            'div',
            { className: "disclaimer font-dark-gray" },
            textContent
          )
        )
      );
    }
  }, {
    key: 'renderSubHeaderAndList',
    value: function renderSubHeaderAndList(subHeader, list) {
      var additionalClasses = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";

      return _react2.default.createElement(
        'div',
        { className: additionalClasses },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'span',
            { className: 'tag' },
            subHeader
          )
        ),
        _react2.default.createElement(
          'div',
          { className: "category" },
          list
        )
      );
    }
  }]);

  return KeyRisksCard;
}(_react2.default.PureComponent);

exports.default = (0, _reactIntl.injectIntl)(KeyRisksCard);